<template>
  <el-drawer :title="title" :visible.sync="innerVisible" size="950px" direction="rtl"
    @close="$emit('update:visible', false);" :wrapperClosable="false" :close-on-press-escape="false">
    <div v-loading="loading" :element-loading-text=promptText element-loading-spinner="el-icon-loading">
      <component v-if="currentComp" height="calc(100vh - 83px)" :visible.sync="innerVisible" :is="currentComp"
        v-bind="$attrs" v-on="$listeners" @loadingPopupWindow="loadingPopupWindow" />
    </div>
  </el-drawer>
</template>

<script>
import { capabilityRegistry } from './introduceComponents.js'

export default {
  name: 'DrawerContainer',

  inheritAttrs: false,

  props: {
    visible: Boolean,
    capabilityKey: {
      type: String,
    },
    title: String
  },

  data() {
    return {
      innerVisible: false,
      loading: false,
      promptText: this.$t('common.loadingEllipsis'),
      currentComp: null
    }
  },

  watch: {
    visible(val) {
      this.innerVisible = val
    },

    capabilityKey: {
      immediate: true,
      async handler(key) {
        if (!key) return

        const loader = capabilityRegistry[key]
        if (!loader) {
          console.error(`[DrawerContainer] 未找到组件：${key}`)
          return
        }

        const mod = await loader()
        this.currentComp = mod.default || mod
      }
    }
  },
  methods: {
    // 内部 input 触发时自动调用父组件传入的 onInput
    loadingPopupWindow(type, string = this.$t('common.loadingEllipsis')) {
      this.loading = type
      this.promptText = string
    }
  },
}
</script>
<style scoped lang="scss">
/deep/ .el-drawer__body {
  padding-left: 16px;
  overflow: hidden;
}

/deep/ .el-drawer__header {
  padding-left: 30px;
}
</style>